module.exports = __webpack_public_path__ + "img/Terranova_MapaUbicacion.44f27a99.png";